import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const useParamSupplierId = () => {
  const params = useParams();
  const location = useLocation();
  const [selectedSupplierId, setSelectedSupplierId] = useState<string | null>(null);

  useEffect(() => {
    if (params && params.supplierId) {
      setSelectedSupplierId(params.supplierId);
    } else {
      setSelectedSupplierId(null);
    }
    return () => {};
  }, [location.pathname]);

  return [selectedSupplierId];
};
